module.exports = __webpack_public_path__ + "static/media/scan2.088cfd2c.png";